import { OPEN_PROFILE, CLOSE_PROFILE } from '../constants/index'

export const openProfile = () => {
  return {
    type: OPEN_PROFILE,
    payload: true
  }
}

export const closeProfile = () => {
  return {
    type: CLOSE_PROFILE,
    payload: false
  }
}
